module.exports = __webpack_public_path__ + "static/img/img.e95e2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.jpg
// module id = Rx1w
// module chunks = 1